export const LINK_API_BASE_URL = import.meta.env.VITE_LINK_BASE_URL;
export const CONNECT_API_BASE_URL = LINK_API_BASE_URL + "/connect";
export const MEAL_BOOKINGS_API_BASE_URL = LINK_API_BASE_URL + "/meal_bookings";
export const PUSH_NOTIFICATIONS_API_BASE_URL =
  LINK_API_BASE_URL + "/push_notifications";
export const SURVEYS_API_BASE_URL = LINK_API_BASE_URL + "/surveys";
export const MEALS_BASE_URL = LINK_API_BASE_URL + "/meals";
export const MEAL_PLAN_BASE_URL = LINK_API_BASE_URL + "/meal_plans";
